module.exports = __webpack_public_path__ + "img/map-marker-alt.2f0e1586.svg";